import { UserProfileUpdate } from "@supernova-studio/model";
import { z } from "zod";

/**
 * Definition of a user profile as inspectable by other users (i.e. reduced version)
 */
export const DTOUserProfile = z.object({
  name: z.string(),
  nickname: z.string().optional(),
  avatar: z.string().optional(),
});

/**
 * Definition of a user as inspectable by other users (i.e. reduced version)
 */
export const DTOUser = z.object({
  id: z.string(),
  email: z.string(),
  profile: DTOUserProfile,
});

export const DTOUserGetResponse = z.object({
  user: DTOUser,
});

export const DTOUserProfileUpdate = UserProfileUpdate;

export type DTOUserProfile = z.infer<typeof DTOUserProfile>;
export type DTOUser = z.infer<typeof DTOUser>;
export type DTOUserGetResponse = z.infer<typeof DTOUserGetResponse>;
export type DTOUserProfileUpdate = z.infer<typeof DTOUserProfileUpdate>;
